module.exports = __webpack_public_path__ + "img/brushes-mobile_en.38a2018.jpg";